import React from 'react';

interface IRelationshipTypeIconProps {
	type: string;
	size?: number;
}

const RELATION_ICON_EXT = '.svg';
const RELATION_ICON_NAMES = [
	'association',
	'access',
	'flow',
	'serving',
	'influence',
	'realization',
	'aggregation',
	'composition',
	'assignment',
	'specialization',
	'triggering',
];

/** Иконка типа связи: SVG (public/archi-relation-icons), нотация ArchiMate. */
const RelationshipTypeIcon: React.FC<IRelationshipTypeIconProps> = ({type, size = 24}) => {
	const iconName = type.trim().toLowerCase();
	const hasIcon = RELATION_ICON_NAMES.includes(iconName);

	if (hasIcon) {
		return (
			<img
				src={`/archi-relation-icons/${iconName}${RELATION_ICON_EXT}`}
				alt=""
				width={size}
				height={size}
				style={{flexShrink: 0, display: 'block', objectFit: 'contain'}}
			/>
		);
	} else {
		return (
			<span
				style={{
					width: size,
					height: size,
					display: 'inline-flex',
					alignItems: 'center',
					justifyContent: 'center',
					fontSize: Math.round(size * 0.6),
					color: '#666',
					flexShrink: 0,
				}}
			>
				{type?.toString().charAt(0) ?? '?'}
			</span>
		);
	}
};

export default RelationshipTypeIcon;
